import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ValAddFourDropDownData } from './valaddfour-drop-down-model';

export class ValAddFourDropDownDataResponseModel extends GlobalResponseObject{
    data?: ValAddFourDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //ValAddFourDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: ValAddFourDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
